export const specializationOptions = {
  Physiotherapy: [
    "Orthopedic Physiotherapy",
    "Neurological Physiotherapy",
    "Cardiovascular Physiotherapy",
    "Pediatric Physiotherapy",
    "Geriatric Physiotherapy"
  ],
  "Massage Therapy": [
    "Sports Massage",
    "Deep Tissue Massage",
    "Swedish Massage",
    "Myofascial Release",
    "Trigger Point Therapy"
  ],
  Chiropractic: [
    "Sports Chiropractic",
    "Pediatric Chiropractic",
    "Neurological Chiropractic",
    "Geriatric Chiropractic"
  ],
  Orthopaedics: [
    "Orthopedic Surgery",
    "Pediatric Orthopedics",
    "Spine Surgery",
    "Sports Medicine Orthopedics",
    "Trauma Orthopedics"
  ],
  "Certified Reflexologist": [
    "Foot Reflexology",
    "Hand Reflexology",
    "Ear Reflexology",
    "Facial Reflexology",
    "Maternity Reflexology"
  ],
  Acupuncture: [ 
    "Traditional Chinese Acupuncture",
    "Electro-Acupuncture",
    "Auricular Acupuncture",
    "Scalp Acupuncture",
    "Cupping Therapy"
  ],
  Osteopath: [
    "Cranial Osteopathy",
    "Visceral Osteopathy",
    "Structural Osteopathy",
    "Pediatric Osteopathy",
    "Musculoskeletal Osteopathy"
  ]
};
